import type { CTAObject } from "types/contentful";

export interface CTAObjectProps {
  text: string;
  link: string;
  trackingId: string;
  size: string;
  variant: string;
  hubspotFormId: string;
  hubspotTitle: string;
  hubspotSubtitle: string;
}

export const ctaObjectDefaults: CTAObjectProps = {
  text: "",
  link: "",
  trackingId: "",
  size: "",
  variant: "",
  hubspotFormId: "",
  hubspotTitle: "",
  hubspotSubtitle: ""
};

export const contentfulCTAObjectToCTA = (
  ctaObject: CTAObject
): CTAObjectProps => ({
  text: ctaObject?.fields?.text || ctaObjectDefaults.text,
  link: ctaObject?.fields?.link || ctaObjectDefaults.link,
  trackingId: ctaObject?.fields?.trackingId || ctaObjectDefaults.trackingId,
  size: ctaObject?.fields?.size || ctaObjectDefaults.size,
  variant: ctaObject?.fields?.variant || ctaObjectDefaults.variant,
  hubspotFormId:
    ctaObject?.fields?.hubspotFormId || ctaObjectDefaults.hubspotFormId,
  hubspotTitle:
    ctaObject?.fields?.hubspotTitle || ctaObjectDefaults.hubspotTitle,
  hubspotSubtitle:
    ctaObject?.fields?.hubspotSubtitle || ctaObjectDefaults.hubspotSubtitle
});
